<template>
    <div class="product-i-post">
        <span
            class="product-i-post__link"
            @click="isOpen = true"
        >
            <svg class="product-i-post__icon"><use xlink:href="#svg-thunder"></use></svg>
            <DefLink>
                <span>
                    {{ messages.fastDelivery }}
                </span>
            </DefLink>
        </span>
        <DefSlideModal
            :active="isOpen"
            @close="isOpen = false"
        >
            <template #title>
                <span>
                    {{ messages.fastDelivery }}
                </span>
            </template>
            <IPostModal
                :product="product"
                :messages="messages"
            />
        </DefSlideModal>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import { useStore } from 'vuex';

import DefLink from "../../def/DefLink/DefLink";
import DefSlideModal from "../../def/DefSlideModal/DefSlideModal";
import DefProgramMe from "../../def/DefProgramMe/DefProgramMe";

const { product, messages } = defineProps(['product', 'messages']);
const { state, getters } = useStore();
const isOpen = ref(false);
</script>

<script>
export default {
    name: 'ProductIPost',
}
</script>

<style lang="scss" scoped>
.product-i-post{
    &__link{
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }
    &__icon{
        width: 18px;
        height: 18px;
        margin-right: 6px;
        fill: var(--background-black);
    }
}
</style>